module.exports = __webpack_public_path__ + "media/elevadizo/buque-di-e7b55c2f.png";